import { render, staticRenderFns } from "./FormPreco.vue?vue&type=template&id=ddc8f1e0&scoped=true&"
import script from "./FormPreco.vue?vue&type=script&lang=js&"
export * from "./FormPreco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc8f1e0",
  null
  
)

export default component.exports